var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 37 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M0 0H36.339V44.958H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.973 22.075H30.307V25.278H6.973z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.478 9.905L6.032 16.08l.905 3.082 22.445-6.176-.904-3.081z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.973 28.534H30.307V31.737H6.973z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.973 34.993H30.307V38.196000000000005H6.973z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.333-.263v-.121h.255v.285a.289.289 0 01-.109.078.334.334 0 01-.142.033.271.271 0 01-.259-.17.48.48 0 01-.038-.201c0-.079.013-.146.039-.202a.296.296 0 01.102-.126.272.272 0 01.15-.041c.07 0 .126.018.168.053.042.036.07.088.082.157l-.118.027a.146.146 0 00-.048-.084.123.123 0 00-.084-.029.152.152 0 00-.123.058c-.031.04-.046.099-.046.18a.33.33 0 00.05.197.142.142 0 00.118.058.229.229 0 00.139-.061v-.091H.333z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(492.222 199.277) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.06 0v-.716h.25c.063 0 .109.007.136.019.028.013.05.036.068.067a.24.24 0 01.026.114.216.216 0 01-.04.136.18.18 0 01-.115.064.26.26 0 01.063.06c.017.022.039.06.068.116L.587 0H.446L.36-.156a1.032 1.032 0 00-.063-.105.088.088 0 00-.035-.03.166.166 0 00-.059-.008H.178V0H.06zm.118-.413h.088A.43.43 0 00.369-.42a.065.065 0 00.035-.029.104.104 0 00.014-.057.1.1 0 00-.014-.055.065.065 0 00-.037-.028.419.419 0 00-.096-.006H.178v.182z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(549.088 199.277) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.06 0v-.716h.436v.121H.178v.159h.295v.121H.178v.194h.328V0H.06z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(603.016 199.277) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.06 0v-.716h.436v.121H.178v.159h.295v.121H.178v.194h.328V0H.06z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(654.1 199.277) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.061 0v-.716h.118v.319l.24-.319h.16l-.221.279L.591 0H.437L.275-.336l-.096.12V0H.061z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(705.185 199.277) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.061 0v-.716h.402v.121H.179v.17h.246v.121H.179V0H.061z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(790.011 199.277) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0.056 -0.716H0.174V0H0.056z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(838.189 199.277) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.063 0v-.71h.118v.589h.295V0H.063z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(869.087 199.277) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.058 0v-.716h.177l.107.489.106-.489h.178V0h-.11v-.564L.399 0H.285L.168-.564V0h-.11z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(917.266 199.277) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.589 0H.461L.409-.162H.175L.126 0H0l.229-.716h.125L.589 0zM.371-.283L.29-.549l-.079.266h.16z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(492.222 298.589) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.06 0v-.716h.25c.063 0 .109.007.136.019.028.013.05.036.068.067a.24.24 0 01.026.114.216.216 0 01-.04.136.18.18 0 01-.115.064.26.26 0 01.063.06c.017.022.039.06.068.116L.587 0H.446L.36-.156a1.032 1.032 0 00-.063-.105.088.088 0 00-.035-.03.166.166 0 00-.059-.008H.178V0H.06zm.118-.413h.088A.43.43 0 00.369-.42a.065.065 0 00.035-.029.104.104 0 00.014-.057.1.1 0 00-.014-.055.065.065 0 00-.037-.028.419.419 0 00-.096-.006H.178v.182z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(568.943 298.589) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.436-.263l.114.044a.322.322 0 01-.089.176.224.224 0 01-.154.055.228.228 0 01-.186-.088.426.426 0 01-.082-.276c0-.122.028-.217.083-.286a.234.234 0 01.193-.09.22.22 0 01.165.067c.032.032.055.08.069.142l-.117.035a.149.149 0 00-.045-.089.11.11 0 00-.079-.031.126.126 0 00-.106.056c-.027.038-.041.1-.041.187 0 .09.013.154.04.193a.123.123 0 00.104.057.106.106 0 00.081-.037.233.233 0 00.05-.115z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(645.663 298.589) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.06 0v-.716h.118v.282h.233v-.282h.118V0H.411v-.313H.178V0H.06z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(722.384 298.589) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0.056 -0.716H0.174V0H0.056z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(799.105 298.589) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.21 0L0-.716h.128l.149.53.144-.53h.126L.336 0H.21z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(852.794 298.589) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.06 0v-.716h.436v.121H.178v.159h.295v.121H.178v.194h.328V0H.06z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(926.671 298.589) scale(63.3114)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.038-.081v-.138l.281-.135-.281-.134v-.137l.403.213v.117l-.403.214z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) translate(492.222 401.9) scale(73.3333)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.061 0v-.716h.402v.121H.179v.17h.246v.121H.179V0H.061z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) matrix(64 0 0 64 665.543 395.233)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0.056 -0.716H0.174V0H0.056z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) matrix(64 0 0 64 755.206 395.233)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.063 0v-.71h.118v.589h.295V0H.063z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) matrix(64 0 0 64 827.399 395.233)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.058 0v-.716h.177l.107.489.106-.489h.178V0h-.11v-.564L.399 0H.285L.168-.564V0h-.11z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) matrix(64 0 0 64 917.062 395.233)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.058 0v-.716h.177l.107.489.106-.489h.178V0h-.11v-.564L.399 0H.285L.168-.564V0h-.11z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) matrix(52 0 0 52 492.222 473.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.059-.716h.118v.388c0 .06.001.099.004.118a.118.118 0 00.038.073.113.113 0 00.078.026.11.11 0 00.067-.019.09.09 0 00.035-.05.587.587 0 00.01-.14v-.396h.118v.376a.928.928 0 01-.016.208.173.173 0 01-.069.104.23.23 0 01-.142.04.27.27 0 01-.144-.033.185.185 0 01-.074-.093.679.679 0 01-.023-.22v-.382z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) matrix(52 0 0 52 583.384 473.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.03-.233l.116-.014c.013.091.055.137.127.137a.121.121 0 00.085-.028.093.093 0 00.031-.069.077.077 0 00-.011-.042.077.077 0 00-.033-.028.877.877 0 00-.106-.037.342.342 0 01-.111-.05.178.178 0 01-.056-.07.212.212 0 01-.021-.094c0-.039.009-.074.027-.105a.172.172 0 01.073-.071.255.255 0 01.116-.024c.069 0 .123.019.162.056a.227.227 0 01.061.161l-.118.006C.366-.543.355-.57.338-.585.321-.601.296-.608.264-.608c-.032 0-.056.006-.074.02a.058.058 0 00-.025.049c0 .02.007.036.023.049a.325.325 0 00.108.044.45.45 0 01.129.055.18.18 0 01.061.073.263.263 0 01.021.11.224.224 0 01-.058.157C.411-.009.351.012.27.012.126.012.046-.07.03-.233z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) matrix(52 0 0 52 669.797 473.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.06 0v-.716h.436v.121H.178v.159h.295v.121H.178v.194h.328V0H.06z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) matrix(52 0 0 52 753.875 473.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.059-.716h.118v.388c0 .06.001.099.004.118a.118.118 0 00.038.073.113.113 0 00.078.026.11.11 0 00.067-.019.09.09 0 00.035-.05.587.587 0 00.01-.14v-.396h.118v.376a.928.928 0 01-.016.208.173.173 0 01-.069.104.23.23 0 01-.142.04.27.27 0 01-.144-.033.185.185 0 01-.074-.093.679.679 0 01-.023-.22v-.382z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) matrix(52 0 0 52 837.952 473.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M.058 0v-.716h.177l.107.489.106-.489h.178V0h-.11v-.564L.399 0H.285L.168-.564V0h-.11z",
    transform: "matrix(.07813 0 0 .07813 -38.543 37.898) matrix(52 0 0 52 924.366 473.9)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfa);
export default __webpack_public_path__ + "static/media/gfa.95cc76f24775a0da6cf11a57b6790aea.svg";
export { ForwardRef as ReactComponent };